import { Button } from "components/DesignSystem/Button/Button";
import { CalendarIcon } from "components/icons/CalendarIcon";
import { FilledTriangleWarning } from "components/icons/FilledTriangleWarning";
import dayjs from "dayjs";
import { useModal } from "hooks/useModal";
import "react-datepicker/dist/react-datepicker.css";
import { ChatTicket } from "types/Models/chatTicket";
import { formatDate } from "utils/formatDate";
import { AddTicketEtd } from "./AddTicketEtd";
import { TicketEtdModal } from "./TicketEtdModal";
import { YYYY_MM_DD } from "constants/date";

export const TicketETD = ({
  rowData,
  isResolved,
}: {
  rowData: ChatTicket;
  isResolved: boolean;
}) => {
  const etdModal = useModal();
  const addEtdModal = useModal();
  const today = dayjs().startOf("day");
  const etd = dayjs(rowData.etd_date, YYYY_MM_DD).startOf("day");
  const diff = etd.diff(today, "day");
  const etdUnset = !rowData.etd_date;

  return (
    <span onClick={(e) => e.stopPropagation()} className="t-flex">
      <div className="t-flex t-gap-0.5 t-flex-col t-w-fit">
        {etdUnset ? (
          <Button
            type="button"
            size="small"
            onClick={addEtdModal.open}
            disabled={rowData.resolved}
          >
            Add ETD
          </Button>
        ) : (
          <Button
            type="button"
            size="small"
            onClick={etdModal.open}
            disabled={rowData.resolved}
            rightIcon={<CalendarIcon className="t-text-text-30 -t-mt-0.5" />}
          >
            {formatDate(rowData.etd_date)}
          </Button>
        )}
        {!isResolved && (
          <>
            {rowData.is_etd_overdue && (
              <div className="t-flex t-text-body-sm t-text-red t-gap-0.5 t-items-center">
                <FilledTriangleWarning />
                Overdue
              </div>
            )}
            {rowData.is_etd_upcoming && (
              <div className="t-flex  t-text-body-sm t-text-yellow-80 t-gap-0.5 t-items-center">
                <FilledTriangleWarning />
                Due in {diff} days
              </div>
            )}
          </>
        )}
      </div>
      {etdModal.isOpen && rowData.etd_date && rowData.company_group?.uuid && (
        <TicketEtdModal
          {...etdModal}
          ticketId={rowData.uuid}
          currentEtd={rowData.etd_date}
          channelUrl={rowData.channel_url}
          groupId={rowData.company_group.uuid}
          ticketName={rowData.name}
        />
      )}
      {addEtdModal.isOpen && (
        <AddTicketEtd {...addEtdModal} ticketId={rowData.uuid} />
      )}
    </span>
  );
};
